<template>
    <div v-if="timeRemaining" :class="{ 'countdown--compact': compact }">
        <template v-if="compact">
            <span>{{ pad(timeRemaining.days) }}</span>
            <span class="countdown__sep" aria-hidden="true">:</span>
            <span>{{ pad(timeRemaining.hours) }}</span>
            <span class="countdown__sep" aria-hidden="true">:</span>
            <span>{{ pad(timeRemaining.minutes) }}</span>
            <span class="countdown__sep" aria-hidden="true">:</span>
            <span>{{ pad(timeRemaining.seconds) }}</span>
        </template>
        <template v-else>
            <span>{{ timeRemaining.days }}<span>روز</span></span>
            <span>{{ timeRemaining.hours }}<span>ساعت</span></span>
            <span>{{ timeRemaining.minutes }}<span>دقیقه</span></span>
            <span>{{ timeRemaining.seconds }}<span>ثانیه</span></span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'Countdown',
    props: {
        endDate: {
            type: String,
            required: true
        },
        serverDate: {
            type: String,
            required: true
        },
        compact: {
            type: Boolean,
            default: false
        },
        reloadOnFinish: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timeRemaining: null,
            interval: null,
            skew: 0,
            hasReloaded: false
        };
    },
    computed: {
        endTime() {
            const value = new Date(this.endDate).getTime();
            return Number.isFinite(value) ? value : NaN;
        },
        serverTime() {
            const value = new Date(this.serverDate).getTime();
            return Number.isFinite(value) ? value : Date.now();
        }
    },
    methods: {
        pad(value) {
            return String(value).padStart(2, '0');
        },
        calculateTimeRemaining() {
            if (!Number.isFinite(this.endTime)) {
                this.timeRemaining = null;
                return;
            }

            const now = Date.now() + this.skew;
            const distance = this.endTime - now;

            if (distance < 0) {
                clearInterval(this.interval);
                this.timeRemaining = null;

                if (this.reloadOnFinish && !this.hasReloaded) {
                    this.hasReloaded = true;
                    window.location.reload();
                }

                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            this.timeRemaining = { days, hours, minutes, seconds };
        }
    },
    mounted() {
        this.skew = this.serverTime - Date.now();
        this.calculateTimeRemaining();
        this.interval = setInterval(this.calculateTimeRemaining, 1000);
    },
    beforeUnmount() {
        clearInterval(this.interval);
    }
};
</script>
